// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-map{max-width:100%;height:auto;width:100%}\n", "",{"version":3,"sources":["webpack://src/components/MapContainer.scss"],"names":[],"mappings":"AAAA,WACI,cAAe,CACf,WAAY,CACZ,UAAW","sourcesContent":[".popup-map {\n    max-width: 100%;\n    height: auto;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
